<div class="wizzards">
    <div class="wizzards__inner">
        <ng-container [ngSwitch]="type">
            <shared-wizzard-for-standard-menu-flow [showDisclaimer]="showDisclaimer"
                *ngSwitchCase="'standard-menu-flow'" [type]="type" [menuFlowId]="menuFlowId" [locationNo]="locationNo">
            </shared-wizzard-for-standard-menu-flow>

            <shared-wizzard-for-enhanced-menu-flow [showDisclaimer]="showDisclaimer"
                *ngSwitchCase="'enhanced-menu-flow'" [type]="type" [menuFlowId]="menuFlowId" [locationNo]="locationNo">
            </shared-wizzard-for-enhanced-menu-flow>

            <shared-wizzard-for-step-through-menu-flow [showDisclaimer]="showDisclaimer"
                *ngSwitchCase="'step-through-menu-flow'" [type]="type" [menuFlowId]="menuFlowId"
                [locationNo]="locationNo">
            </shared-wizzard-for-step-through-menu-flow>

            <shared-wizzard-for-combined-pages-menu-flow [showDisclaimer]="showDisclaimer"
                *ngSwitchCase="'combined-pages-menu-flow'" [type]="type" [menuFlowId]="menuFlowId"
                [locationNo]="locationNo">
            </shared-wizzard-for-combined-pages-menu-flow>



            <shared-wizzard-for-upsell [showDisclaimer]="showDisclaimer" *ngSwitchCase="'upsell'" [type]="type"
                [menuFlowId]="menuFlowId" [locationNo]="locationNo">
            </shared-wizzard-for-upsell>

            <shared-wizzard-for-product [showDisclaimer]="showDisclaimer" *ngSwitchCase="'product'" [type]="type"
                [menuFlowId]="menuFlowId" [locationNo]="locationNo">
            </shared-wizzard-for-product>

            <ng-container *ngSwitchDefault>
                WIZZARD NOT SUPPORTED [{{type}}]
            </ng-container>

        </ng-container>
    </div>
</div>